import { render } from "./AllOrders.vue?vue&type=template&id=02f83a3a&scoped=true"
import script from "./AllOrders.vue?vue&type=script&lang=js"
export * from "./AllOrders.vue?vue&type=script&lang=js"

import "./AllOrders.vue?vue&type=style&index=0&id=02f83a3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f83a3a"]])

export default __exports__